import { ImageConfig } from "./../models/client/image-config";
import { Position } from "../models/client";

export interface VideoWallConfig {
  widthFactor: number;
  heightFactor: number;
  videos: Video[];
}

export interface Video {
  id: number;
  name: string;
  position: Position;
  displayWidth: number;
  width: number;
  height: number;
  previewImg: ImageConfig;
  src: string;
}

export const videoWallConfig: VideoWallConfig = {
  widthFactor: 2.2,
  heightFactor: 2,
  videos: [
    {
      id: 4,
      name: "Lorem ipsum et dolor",
      position: {
        x: 70,
        y: 80,
      },
      displayWidth: 25,
      width: 300,
      height: 250,
      previewImg: {
        src: "/assets/images/do-you-have-something-for/advertisement_1930s.jpg",
        title: "hero image",
      },
      src: "https://storage.coverr.co/videos/TlvnlTv5E96LyrDQv02djaTblzt1Sj7hx?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6Ijg3NjdFMzIzRjlGQzEzN0E4QTAyIiwiaWF0IjoxNjQ4NjM3NjE0fQ.JrwIJfn8rzkBcfyawSwL-Xs6UGZ66i1VTTD4OygjFJc",
    },
    {
      id: 3,
      name: "Lorem ipsum et dolor",
      position: {
        x: 60,
        y: 15,
      },
      displayWidth: 30,
      width: 450,
      height: 250,
      previewImg: {
        src: "/assets/images/at-your-service/in-store_poster_2020.jpg",
        title: "hero image",
      },
      src: "https://storage.coverr.co/videos/r8a018WMWvAtNiAK500VDN4pwI8beMH7DG?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6Ijg3NjdFMzIzRjlGQzEzN0E4QTAyIiwiaWF0IjoxNjQ2OTI3MzI1fQ.JqveXMwWSpxoMos0M1Wpc8XBsSsVpnT3Ob2nqxjBpPk",
    },
    {
      id: 2,
      name: "Lorem ipsum et dolor",
      position: {
        x: 20,
        y: 75,
      },
      displayWidth: 30,
      width: 450,
      height: 250,
      previewImg: {
        src: "/assets/images/nhs/boots_church_street_liverpool_store_c1959.jpg",
        title: "hero image",
      },
      src: "https://storage.coverr.co/videos/nf3ffqKMlAlIEdQnW302jWojn02N02lvPMI?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6Ijg3NjdFMzIzRjlGQzEzN0E4QTAyIiwiaWF0IjoxNjQ2OTI3NDA5fQ.T_DbkU72GiSE2aRXK0W3IdHIflcU2cIr_nTaf11fNEM",
    },
    {
      id: 1,
      name: "Lorem ipsum et dolor",
      position: {
        x: 13,
        y: 22,
      },
      displayWidth: 30,
      width: 450,
      height: 250,
      previewImg: {
        src: "/assets/images/professionalism/boots_attendees_training_course_1926.jpg",
        title: "hero image",
      },

      src: "https://storage.coverr.co/videos/bictqEaM7K02pMCMBssCJ4TKng01TPZHH2?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6Ijg3NjdFMzIzRjlGQzEzN0E4QTAyIiwiaWF0IjoxNjQ2OTI3NDA5fQ.T_DbkU72GiSE2aRXK0W3IdHIflcU2cIr_nTaf11fNEM",
    },
    {
      id: 0,
      name: "Lorem ipsum et dolor",
      position: {
        x: 45,
        y: 45,
      },
      displayWidth: 55,
      width: 450,
      height: 250,
      previewImg: {
        src: "/assets/images/home_scene.jpg",
        title: "hero image",
      },
      src: "https://storage.coverr.co/videos/TObznTzFdschl88ju5Euh841jZO2fIwr?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6Ijg3NjdFMzIzRjlGQzEzN0E4QTAyIiwiaWF0IjoxNjQ2OTI3NTAyfQ.E3g066tgvlTt2xHA8oZ_QvsEEPdgCIZyrKhAz2Z3joU",
    },
    {
      id: 20,
      name: "Lorem ipsum et dolor",
      position: {
        x: 28,
        y: 50,
      },
      displayWidth: 30,
      width: 450,
      height: 250,
      previewImg: {
        src: "/assets/images/home_scene.jpg",
        title: "hero image",
      },
      src: "https://storage.coverr.co/videos/wXAv3SxKSMVPSEVwJXwfs8zvkHNp53BQ?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhcHBJZCI6Ijg3NjdFMzIzRjlGQzEzN0E4QTAyIiwiaWF0IjoxNjQ4NjM3ODI5fQ.uzOK3plViPFY9GELViubZ9k7Anc3KWMQSGeHv2g-xi0",
    },
  ],
};
